var moduleMap = {
	"./product-grid": () => {
		return Promise.resolve().then(() => (() => ((__webpack_require__("./src/exported/product-grid-wrapper/index.ts")))));
	},
	"./product-basic-info": () => {
		return Promise.resolve().then(() => (() => ((__webpack_require__("./src/exported/product-basic-info/index.ts")))));
	},
	"./product-brief": () => {
		return Promise.resolve().then(() => (() => ((__webpack_require__("./src/exported/product-brief/index.ts")))));
	},
	"./product-comparison-module": () => {
		return Promise.resolve().then(() => (() => ((__webpack_require__("./src/exported/product-comparison-module/index.ts")))));
	},
	"./product-cross-sell": () => {
		return Promise.resolve().then(() => (() => ((__webpack_require__("./src/exported/product-cross-sell/index.ts")))));
	},
	"./product-cta": () => {
		return Promise.resolve().then(() => (() => ((__webpack_require__("./src/exported/product-cta/index.ts")))));
	},
	"./product-full": () => {
		return Promise.resolve().then(() => (() => ((__webpack_require__("./src/exported/product-full/index.ts")))));
	},
	"./product-media-carousel-nav": () => {
		return Promise.resolve().then(() => (() => ((__webpack_require__("./src/exported/product-image-nav-menu/index.ts")))));
	},
	"./product-quantity-selector": () => {
		return Promise.resolve().then(() => (() => ((__webpack_require__("./src/exported/product-quantity-selector/index.ts")))));
	},
	"./product-shade-picker": () => {
		return Promise.resolve().then(() => (() => ((__webpack_require__("./src/exported/product-shade-picker/index.ts")))));
	},
	"./product-size-picker": () => {
		return Promise.resolve().then(() => (() => ((__webpack_require__("./src/exported/product-size-picker-wrapper/index.ts")))));
	},
	"./product-shade-picker-button": () => {
		return Promise.resolve().then(() => (() => ((__webpack_require__("./src/exported/product-shade-picker-button/index.ts")))));
	},
	"./diContainer": () => {
		return Promise.all(/* diContainer */[__webpack_require__.e("vendors-node_modules_estee_elc-base-theme_src_ContentSpacing_ts-node_modules_estee_elc-servic-049a32"), __webpack_require__.e("vendors-node_modules_estee_elc-formatters_src_business-unit-id-parser_BusinessUnitIdParser_ts-f952dd"), __webpack_require__.e("diContainer")]).then(() => (() => ((__webpack_require__("./src/service-setup/diContainer.tsx")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});